export const fuseConfigurationsConstants = {
  FUSE_CONFIGURATIONS_LOADING: "FUSE_CONFIGURATIONS_LOADING",
  FUSE_CONFIGURATIONS_SUCCESS: "FUSE_CONFIGURATIONS_SUCCESS",
  FUSE_CONFIGURATIONS_FAILURE: "FUSE_CONFIGURATIONS_FAILURE",
};

export const testConfigurationsConstants = {
  TEST_CONFIGURATIONS_LOADING: "TEST_CONFIGURATIONS_LOADING",
  TEST_CONFIGURATIONS_SUCCESS: "TEST_CONFIGURATIONS_SUCCESS",
  TEST_CONFIGURATIONS_FAILURE: "TEST_CONFIGURATIONS_FAILURE",
};

export const provisionConfigurationsConstants = {
  PROVISIONING_CONFIGURATIONS_LOADING: "PROVISIONING_CONFIGURATIONS_LOADING",
  PROVISIONING_CONFIGURATIONS_SUCCESS: "PROVISIONING_CONFIGURATIONS_SUCCESS",
  PROVISIONING_CONFIGURATIONS_FAILURE: "PROVISIONING_CONFIGURATIONS_FAILURE",
};
